export default (state) => !!state.webAuthN.isSupported
